import { Box, CardMedia, Container } from '@mui/material';
import React from 'react';
import theme from '../../theme';
import Text from './Text';
import Images from '../../services/data/images';

const styles = {
  cover: {
    height: theme.spacing(35),
  },
  title: {
    background: '#B7B5D8',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
};

interface Props {
  cover: string;
  title: string;
  base64Cover?: boolean;
}

const Header: React.FC<Props> = ({ cover, title, base64Cover = false }) => {
  return (
    <header>
      <CardMedia
        component="img"
        src={base64Cover ? cover : Images[cover]}
        sx={styles.cover}
      />
      <Box style={styles.title}>
        <Container>
          <Text color="white" size="huge">
            <h1 style={{ fontSize: '35px' }}>{title}</h1>
          </Text>
        </Container>
      </Box>
    </header>
  );
};

export default Header;
